<template>
    <div class="table">
        <div class="table-row table-header">
            <slot name="table-header"></slot>
        </div>
        <div style="height: 1px; width: 100%; background: #eee" />
        <slot name="table-content"></slot>
    </div>
</template>

<script>
export default {
    name: 'ProcessChargesTable'
};
</script>
<style scoped lang="scss">
.table {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    border-radius: 25px;
}

.table-row {
    display: grid;
    grid-template-columns: 50px 170px 115px 120px 160px 1fr 75px 75px 110px 140px 120px 120px 100px 80px;
    grid-template-areas: 'checkbox refNo tripDate customerName serviceName time attempt run-number status driverName charge cost margin actions';
    align-items: center;
    gap: 8px;

    &:first-child {
        padding-left: 8px;
    }
}

.table-header {
    padding-top: 23px;
    padding-bottom: 23px;
    background: #fff;
    color: #4caf50 !important;
    white-space: nowrap;
    overflow: visible;
}

@media (max-width: 1600px) {
    .table-row {
        grid-template-columns: 40px 150px 110px 150px 170px 90px 90px 120px 130px 110px 65px;
        grid-template-areas: 'checkbox refNo tripDate customerName serviceName time status driverName charge cost actions';
    }
}
</style>
